module.exports = __webpack_public_path__ + "img/22_73.dfd8ee7e.png";